export default __webpack_public_path__ + "static/media/MPPIcon.b20ca674.svg";